import * as Config from '../../constants/config';
import React from 'react';
import ReactDOM from 'react-dom';
import styles from './styles.less';
import isMobile from 'ismobilejs';
import cx from 'classnames';
import {debounce} from 'lodash';
import UploadForm from '../upload-form';

class Comic extends React.Component {

    static defaultProps = {
        brushColor: '#ff0000',
        lineWidth: 2,
        eraserWidth: 10,
        canvasStyle: {
            backgroundColor: 'transparent',
            maxWidth: '100%'
        },
        clear: false
    };

    constructor(props) {
        super(props);
        this.state = {
            canvas: null,
            context: null,
            drawing: false,
            lastX: 0,
            lastY: 0,
            history: [],
            pencil: true,
            eraser: false,
            uploading: false,
            uploadForm: false,
            imageDataUrl: null
        };
    }

    getDefaultStyle() {
        return {
            backgroundColor: 'transparent',
            maxWidth: '100%'
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize, false);
        let canvas = ReactDOM.findDOMNode(this).getElementsByTagName('canvas')[0];
        let image = canvas.offsetParent.getElementsByTagName('img')[0];

        canvas.width  = image.offsetWidth;
        canvas.height = image.offsetHeight;

        let context = canvas.getContext('2d');

        var background = new Image();
        background.src = '/comics/proxy?url=' + image.getAttribute('src');
        // Make sure the image is loaded first otherwise nothing will draw.
        background.onload = function() {
            context.drawImage(background, 0, 0, background.width, background.height, 0, 0, canvas.width, canvas.height);
        };

        this.setState({
            canvas: canvas,
            context: context
        });
    }

    handleResize = debounce(() => { this.resetCanvas() }, 100);

    handleOnMouseDown = (e) => {
        let rect = this.state.canvas.getBoundingClientRect();
        this.state.context.beginPath();
        if (isMobile.any) {
            this.setState({
                lastX: e.changedTouches[0].clientX - rect.left,
                lastY: e.changedTouches[0].clientY - rect.top
            });
        } else {
            this.setState({
                lastX: e.clientX - rect.left,
                lastY: e.clientY - rect.top
            });
        }

        this.setState({
            drawing: true
        });
    }

    handleOnMouseMove = (e) => {
        if (this.state.drawing) {
            let rect = this.state.canvas.getBoundingClientRect();
            let lastX = this.state.lastX;
            let lastY = this.state.lastY;
            let currentX;
            let currentY;

            if (isMobile.any) {
                currentX = e.changedTouches[0].clientX - rect.left;
                currentY = e.changedTouches[0].clientY - rect.top;

                // Prevent the whole page from dragging if on mobile
                e.preventDefault();
            } else {
                currentX = e.clientX - rect.left;
                currentY = e.clientY - rect.top;
            }

            this.draw(lastX, lastY, currentX, currentY);
            this.setState({
                lastX: currentX,
                lastY: currentY
            });
        }
    }

    handleOnMouseUp = () => {
        this.setState({
            drawing: false
        });
    }

    draw = (lX, lY, cX, cY) => {
        this.state.context.strokeStyle = this.props.brushColor;
        this.state.context.lineWidth = this.props.lineWidth;

        if (this.state.pencil) {
            this.state.context.moveTo(lX, lY);
            this.state.context.lineTo(cX, cY);
            this.state.context.stroke();
        } else if (this.state.eraser) {
            this.state.context.arc(lX, lY, this.props.eraserWidth, 0, Math.PI * 2, !0);
            this.state.context.fill();
            this.state.context.closePath();
        }
    }

    resetCanvas () {
        let canvas = this.state.context.canvas;
        let image = canvas.offsetParent.getElementsByTagName('img')[0];
        canvas.width  = image.offsetWidth;
        canvas.height = image.offsetHeight;
        let width = canvas.width;
        let height = canvas.height;
        this.state.context.clearRect(0, 0, width, height);
    }

    canvasStyle() {
        let defaults = this.getDefaultStyle();
        let custom = this.props.canvasStyle;
        return Object.assign({}, defaults, custom);
    }

    render() {
        const canvasClasses = cx(styles.canvas, {
            [styles.drawing]: this.state.pencil,
            [styles.erasing]: this.state.eraser
        });

        const pencilStyles = cx(styles.pencil, {
            [styles.enabled]: !!this.state.pencil
        });

        const eraserStyles = cx(styles.eraser, {
            [styles.enabled]: !!this.state.eraser
        });

        const showShare = true;

        return (
            <div className={ this.props.className }>
                <div
                    className={ styles.canvasWrapper }
                    style={ { maxWidth: this.props.maxWidth + '%' } }
                >
                    <div className={ styles.canvasDrawingArea }>
                        { this.props.image }
                        <canvas
                            className={ canvasClasses }
                            onMouseDown={ this.handleOnMouseDown }
                            onMouseMove={ this.handleOnMouseMove }
                            onMouseUp={ this.handleOnMouseUp }
                            onTouchEnd={ this.handleOnMouseUp }
                            onTouchMove={ this.handleOnMouseMove }
                            onTouchStart={ this.handleOnMouseDown }
                            style={ this.canvasStyle() }>
                        </canvas>
                    </div>

                    <div className={ styles.canvasControls }>
                        <div
                            className={ pencilStyles }
                            onClick={ this.handleDraw.bind(this) }
                        >
                            <svg
                                enableBackground="new 0 0 32.6 44.7"
                                viewBox="0 0 32.6 44.7"
                                x="0px"
                                y="0px"><g><g><path d="M20.1,7.7c-5.9,8-11.6,16-17.2,24.2c-0.7,1.1,1,2.1,1.7,1c5.6-8.2,11.3-16.3,17.2-24.2C22.6,7.7,20.9,6.7,20.1,7.7L20.1,7.7z"/></g></g><g><g><path d="M26.6,11.7c-3.3,5-6.5,10.1-9.8,15.1c-1.4,2.2-2.6,4.8-4.3,6.7c-1.5,1.7-2.1,2.7-4.6,1.7C6.6,34.7,5,33,4,32.2c-1-0.8-2.4,0.6-1.4,1.4c2.4,1.8,4.7,4.2,7.5,5.4c0.3,0.1,0.7,0,1-0.3c3.4-2.9,5.6-8.1,8-11.8c3.1-4.8,6.1-9.5,9.2-14.3C29,11.6,27.3,10.6,26.6,11.7L26.6,11.7z"/></g></g><g><g><path d="M2,32.8C1.5,36.4,0.9,39.9,0,43.4c-0.2,0.8,0.7,1.6,1.5,1.1c3.1-1.9,6.2-3.6,9.4-5.3c1.1-0.6,0.1-2.3-1-1.7c-3.2,1.6-6.3,3.4-9.4,5.3C1,43.2,1.5,43.6,2,44c0.9-3.7,1.5-7.4,2-11.2C4.1,31.5,2.1,31.5,2,32.8L2,32.8z"/></g></g><g><g><path d="M1.2,42c0.3,0.1,0.5,0.3,0.6,0.6c0.6-0.3,1.2-0.5,1.8-0.8c-0.3-0.4-0.4-0.7-0.6-1.2c-0.5,0.4-1,0.8-1.5,1.1C2,42,2.4,42.2,2.8,42.5c0.4,0.3,1.1,0.1,1.4-0.4c0.3-0.5,0.1-1.1-0.4-1.4C3.4,40.5,3,40.3,2.7,40c-0.7-0.5-1.7,0.3-1.5,1.1c0.2,0.6,0.4,1.1,0.8,1.6c0.3,0.4,0.8,0.6,1.2,0.4C3.6,43,4,42.5,3.8,42c-0.3-0.8-0.8-1.4-1.6-1.8c-0.5-0.2-1.1-0.1-1.4,0.4C0.6,41,0.7,41.8,1.2,42L1.2,42z"/></g></g><g><g><path d="M20.3,8.1c0.9,1.4,2,2.7,3.2,3.9c0.9,0.8,2.4,2.4,3.6,2.3c0.5,0,0.8-0.3,1-0.7c0,0,0-0.1,0.1-0.1c0.2-0.4-0.1-0.9-0.5-1.1c0,0-0.1,0-0.1-0.1c-1-0.8-2,1-1,1.7c0,0,0.1,0,0.1,0.1c-0.2-0.4-0.3-0.8-0.5-1.1c0,0,0,0.1-0.1,0.1c0.3-0.2,0.6-0.5,1-0.7c0.2,0.1,0.3,0.1,0,0c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.2-0.5-0.4-0.8-0.5c-0.6-0.4-1.1-0.8-1.6-1.3c-1-0.9-1.8-1.9-2.5-3.1C21.3,6,19.6,7,20.3,8.1L20.3,8.1z"/></g></g><g><g><path d="M27.9,12.7c1.1-1.4,2.1-2.9,3-4.4c0.5-0.8,1.9-2.4,1.7-3.5c-0.2-1.1-1.6-1.6-2.4-2.1c-1.4-0.9-2.9-2.2-4.4-2.7c-0.3-0.1-0.7,0-1,0.3c-0.9,0.9-1.4,2.2-2.1,3.3C21.8,5,21,6.5,20.1,7.9c-0.7,1.1,1.1,2.1,1.7,1c0.7-1.2,1.4-2.4,2.1-3.6c0.7-1.1,1.3-2.7,2.2-3.6c-0.3,0.1-0.6,0.2-1,0.3c1,0.3,2,1.2,2.9,1.8c0.9,0.6,2.1,1.1,2.8,1.9c-0.1-0.3-0.2-0.6-0.3-1c-0.7,2.4-2.9,5-4.4,7C25.4,12.7,27.2,13.7,27.9,12.7L27.9,12.7z"/></g></g><g><g><path d="M22.7,6.4c1.7,0.9,3.2,1.8,4.7,3c1,0.8,2-1,1-1.7c-1.5-1.1-3.1-2.1-4.7-3C22.6,4.1,21.6,5.8,22.7,6.4L22.7,6.4z"/></g></g>
                            </svg>
                        </div>

                        <div
                            className={ eraserStyles }
                            onClick={ this.handleErase.bind(this) }
                        >
                            <svg
                                enableBackground="new 0 0 42.5 25.1"
                                viewBox="0 0 42.5 25.1"
                                x="0px"
                                y="0px"><g><g><path d="M23.2,0c-7.6,2.3-15,5-22.3,8.1C0.1,8.5,0.4,9.8,1.1,10c4.1,1,8.1,2.1,12,3.5c2.7,1,4,1.8,6.6,0.8c7.4-2.9,14.5-7,21.7-10.5c1-0.5,0.4-1.8-0.5-1.9c-6.3-0.4-12.6-0.8-19-1.2c-1.3-0.1-1.3,1.9,0,2c6.3,0.4,12.6,0.8,19,1.2c-0.2-0.6-0.3-1.2-0.5-1.9c-5.8,2.8-11.7,5.7-17.5,8.5c-2,1-4.1,2.2-6.5,2c-1.4-0.1-3.2-1.2-4.5-1.6C8.5,9.8,5.1,8.9,1.7,8c0.1,0.6,0.2,1.2,0.2,1.8C9,6.8,16.3,4.2,23.7,2C25,1.6,24.4-0.3,23.2,0L23.2,0z"/></g></g><g><g><path d="M0.2,8.3C0,11.7-0.1,15,0,18.3c0,1.5-0.1,2.8,1.5,3.3c1.2,0.4,2.8,0.2,4.1,0.5c1.4,0.3,2.8,0.7,4.2,1.2c2.2,0.7,4.7,1.7,7,1.3c0.3-0.1,0.6-0.4,0.7-0.7c0.9-2.7,0.6-6.3,0.9-9.2c0.1-1.3-1.9-1.3-2,0c-0.1,1.6,0.3,7.1-1.2,7.9c-0.7,0.4-3.5-0.8-4.3-1.1c-1.2-0.4-2.5-0.8-3.7-1.1c-1-0.2-1.9-0.4-2.9-0.6c-2.1-0.3-2.2,0-2.2-2.2c0-3.1,0-6.2,0.2-9.4C2.3,7,0.3,7,0.2,8.3L0.2,8.3z"/></g></g><g><g><path d="M17,25.1c4.7-1,9.3-2.3,13.7-4c3.1-1.2,8.3-2.7,10.5-5.3c1.9-2.1,1.1-6.1,1.2-8.8c0.1-2,0.6-4-1.5-4.9c-1.2-0.5-1.7,1.5-0.5,1.9c0.4,0.1,0.1,6.9-0.1,7.6c-1.3,4.1-5,5.4-8.6,6.9c-4.9,2.1-10,3.6-15.2,4.7C15.2,23.4,15.7,25.3,17,25.1L17,25.1z"/></g></g>
                            </svg>
                        </div>

                        { (this.state.working !== 'twitter') && showShare &&
                        <div
                            className={ styles.twitter }
                            onClick={ this.handleTwitter.bind(this) }
                        >
                            <svg
                                enableBackground="new 0 0 36.4 28.8"
                                viewBox="0 0 36.4 28.8"
                                x="0px"
                                y="0px"><g><g><path d="M30.8,0.4c-0.9,1-2.1,2.3-3.5,1.7c-0.6-0.2-1.1-0.8-1.6-1.1c-1.6-0.7-3.4-0.8-5-0.1c-3.7,1.5-4.4,5.4-4.1,9c0.2-0.2,0.4-0.3,0.6-0.5c-5.3-1.2-10.1-3.7-14-7.4C3,1.7,2.5,1.8,2.4,2.2c-0.7,3.3-0.3,6.4,1.2,9.4c0.2-0.2,0.5-0.5,0.7-0.7C3,10.3,1.9,10,0.5,10C0.2,10,0,10.2,0,10.5c0,3.6,2.7,6.4,6.2,6.7c0-0.3-0.1-0.7-0.1-1c-1.3,0.2-2.5,0.5-3.7,1c-0.3,0.1-0.5,0.5-0.3,0.7C4,20.5,6.4,23,9.9,22.2c-0.1-0.3-0.3-0.6-0.4-0.9c-2.6,2-5.6,3-8.9,3c-0.4,0-0.6,0.5-0.4,0.9c5.1,5.4,13.3,4.3,18.7,0.1c3.1-2.4,5.8-5.7,7.7-9.2c1-1.8,1.2-5.1,2.7-6.4c1.8-1.6,4.7-2.5,6.8-3.7c0.4-0.2,0.2-1-0.3-0.9c-2.3,0.1-4.6,0.3-6.8,0.4c0.1,0.3,0.2,0.6,0.4,0.9c1.8-1.5,3-3.4,3.7-5.6c0.1-0.4-0.3-0.7-0.6-0.6c-0.7,0.2-1.3,0.5-1.9,0.8c-0.6,0.3-0.1,1.2,0.5,0.9c0.5-0.3,1-0.6,1.6-0.7c-0.2-0.2-0.4-0.4-0.6-0.6c-0.7,2.1-1.8,3.7-3.4,5.2c-0.3,0.3-0.1,0.9,0.4,0.9c2.3-0.1,4.6-0.3,6.8-0.4c-0.1-0.3-0.2-0.6-0.3-0.9c-1.9,1.1-3.9,2.1-5.8,3.2c-1,0.6-1.9,1-2.3,2.2c-0.7,1.8-0.9,3.7-1.9,5.4c-1,1.7-2.2,3.4-3.5,4.9C17,26.7,7.3,31.3,0.9,24.4c-0.1,0.3-0.2,0.6-0.4,0.9c3.5-0.1,6.6-1.1,9.4-3.2c0.4-0.3,0.2-1.1-0.4-0.9c-3.1,0.8-5-1.7-6.6-3.8c-0.1,0.2-0.2,0.5-0.3,0.7c1.2-0.5,2.4-0.8,3.7-1c0.6-0.1,0.4-0.9-0.1-1C4.3,16,2.7,15,1.7,13.4c-0.2-0.3-0.8-1.4-0.7-1.7c0.4-1.2,2.1-0.1,2.7,0.1c0.5,0.2,0.9-0.2,0.7-0.7C3.1,8.3,2.7,5.5,3.3,2.4C3.1,2.5,2.8,2.6,2.5,2.7c4.1,3.9,9,6.5,14.4,7.7c0.3,0.1,0.7-0.1,0.6-0.5c-0.2-2.7-0.1-5.7,2.4-7.4c2.5-1.8,5.5-1.1,7.4,1.1c0.1,0.1,0.3,0.2,0.5,0.1c1.5-0.6,2.7-1.4,3.7-2.6C32,0.6,31.3-0.1,30.8,0.4L30.8,0.4z"/></g></g>
                            </svg>
                        </div>
                        }

                        { (this.state.working === 'twitter') && this.uploadingImage() }

                        { (this.state.working !== 'facebook') && showShare &&
                        <div
                            className={ styles.facebook }
                            onClick={ this.handleFacebook.bind(this) }>
                            <svg
                                enableBackground="new 0 0 23.9 23.5"
                                viewBox="0 0 23.9 23.5"
                                x="0px"
                                y="0px">
                                <g>
                                    <path
                                        d="M9.5,0.6c-2.1-0.1-4.1,0-6.2,0.2C2.8,0.9,2.2,1,1.8,1.3 c-1,0.6-1.2,1.8-1.2,2.9C0.4,9.2,0.5,14.3,1,19.4c0.1,1.2,0.4,2.6,1.5,3.1c0.5,0.2,1,0.3,1.5,0.3c2.3,0.2,4.6,0.2,6.9-0.1 c-0.3-3-0.5-6-0.8-9c0-0.2,0-0.3-0.1-0.5c-0.5-1-2.2-0.2-3.3-0.6c-1.2-0.5-0.9-2.1,0.2-2.7c1.1-0.6,2.4-0.5,3.7-0.3 c-0.8-2.1,0-4.6,1.8-6.1c1.7-1.4,4.2-1.8,6.3-1c2.1,0.8,3.4,3,2.8,4.9c-0.7,0.2-1.5,0.5-2.2,0.7c-0.8-0.8-1-2.2-2.1-2.5 c-1-0.4-2.2,0.4-2.5,1.4c-0.3,0.9-0.1,2,0.2,2.9c0.7-0.6,2-0.2,2.3,0.5c0.4,0.8-0.1,1.7-0.9,2.2c-0.8,0.5-1.8,0.5-2.7,0.3 c0.2,3.3,0.6,6.7,1.3,10c2,0.2,4,0.1,5.8-0.5c0.6-0.2,1.2-0.4,1.6-0.7c0.5-0.4,0.7-1.1,0.8-1.7c0.4-2,0.4-4,0.3-6 c-0.1-3.4-0.2-6.7-0.3-10.1c0-0.7,0-1.4-0.4-2c-0.9-1.4-3-1.4-4.8-1.3c-2.7,0.2-5.4,0.4-8.1,0.5"
                                        fill="none"
                                        stroke="#000000"
                                        strokeMiterlimit="10"
                                    />
                                </g>
                            </svg>
                        </div>
                        }

                        { (this.state.working === 'facebook') && this.uploadingImage() }

                        { (this.state.working !== 'download') &&
                        <div
                            className={ styles.download }
                            onClick={ this.handleDownload.bind(this) }
                        >
                            <svg
                                enableBackground="new 0 0 27.7 35"
                                viewBox="0 0 27.7 35"
                                x="0px"
                                y="0px"><g><g><path d="M0.7,1.4C0.6,4.9,0.5,8.3,0.4,11.8c0,1.7-0.1,3.5-0.1,5.2c0,1.2-0.5,4.1-0.1,5.2c0.9,2.6,4.3,2.2,6.7,2.2c1.3,0,1.3-2,0-2c-3.5,0-4.2-0.2-4.6-3.6C2,17,2.3,15.2,2.4,13.5c0.1-4,0.2-8.1,0.3-12.1C2.7,0.1,0.7,0.1,0.7,1.4L0.7,1.4z"/></g></g><g><g><path d="M13.6,17c0.2,5,0.1,9.9-0.4,14.9c-0.1,1.3,1.9,1.3,2,0c0.5-4.9,0.7-9.9,0.4-14.9C15.5,15.7,13.5,15.7,13.6,17L13.6,17z"/></g></g><g><g><path d="M10.1,30.4c1.3,1.4,2.6,2.9,3.9,4.3c0.5,0.5,1.2,0.3,1.6-0.2c1.1-1.5,2.4-2.9,3.9-4.1c1-0.8-0.4-2.2-1.4-1.4c-1.6,1.4-2.9,2.9-4.2,4.5c0.5-0.1,1-0.1,1.6-0.2c-1.3-1.4-2.6-2.9-3.9-4.3C10.6,28,9.2,29.4,10.1,30.4L10.1,30.4z"/></g></g><g><g><path d="M2.5,2c8.1,0,16.1,0.4,24.2,1.4c-0.3-0.3-0.7-0.7-1-1c0,6.6,0,13.2,0,19.8c0.3-0.3,0.7-0.7,1-1c-1.8,0.1-3.5,0.3-5.3,0.4c-1.3,0.1-1.3,2.1,0,2c1.8-0.1,3.5-0.3,5.3-0.4c0.5,0,1-0.4,1-1c0-6.6,0-13.2,0-19.8c0-0.6-0.5-0.9-1-1C18.7,0.4,10.6,0,2.5,0C1.2,0,1.2,2,2.5,2L2.5,2z"/></g></g>
                            </svg>
                        </div>
                        }

                        { (this.state.working === 'download') && this.uploadingImage() }
                    </div>

                </div>

                { this.props.isSubmittable &&
                <img
                    className={ styles.submitButton }
                    onClick={ this.handleImageSubmit.bind(this) }
                    src="https://i.cdn.turner.com/adultswim/big/img/2017/02/09/submit-button.png"
                />
                }

                { this.state.uploadForm &&
                <UploadForm
                    className={ styles.uploadForm }
                    handleUploadFormClose={ this.uploadFormClose.bind(this) }
                    imageUrl={ this.state.imageDataUrl }
                />
                }
            </div>
        );
    }

    uploadingImage() {
        return (<div className={ styles.uploading }><img src="https://i.cdn.turner.com/adultswim/big/img/2017/02/09/working.gif" /></div>);
    }

    handleDraw() {
        this.state.context.globalCompositeOperation = 'source-over';

        this.setState({
            eraser: false,
            pencil: true
        });
    }

    handleErase() {
        this.state.context.globalCompositeOperation = 'destination-out';

        this.setState({
            eraser: true,
            pencil: false
        });
    }

    handleDownload() {
        this.setState({
            working: 'download'
        });

        // setting a reference to window so we can use it in an async call (safari blocks window.open in async functions)
        let windowReference = null;
        if (this.isSafari()) windowReference = window.open();

        this.getDataUrl().then((dataURL) => {
            this.newImage(dataURL)
                .then((res) => {
                    setTimeout(() => {
                        this.setState({ working: false });
                        const uri = res.data.url;
                        if (!windowReference) window.open(uri, '_blank');
                        else windowReference.location = uri;
                    }, 1000);
                });
        });
    }

    handleFacebook() {
        this.setState({
            working: 'facebook'
        });

        // setting a reference to window so we can use it in an async call (safari blocks window.open in async functions)
        let windowReference = null;
        if (this.isSafari()) windowReference = window.open();

        this.getDataUrl().then((dataURL) => {
            this.newImage(dataURL)
                .then((res) => {
                    setTimeout(() => {
                        this.setState({ working: false });
                        const uri = Config.FACEBOOK_IMAGE_SHARE + encodeURI(res.data.url);
                        if (!windowReference) window.open(uri, '_blank');
                        else windowReference.location = uri;
                    }, 500);
                });
        });
    }

    handleTwitter() {
        this.setState({
            working: 'twitter'
        });

        // setting a reference to window so we can use it in an async call (safari blocks window.open in async functions)
        let windowReference = null;
        if (this.isSafari()) windowReference = window.open();

        this.getDataUrl().then((dataURL) => {
            this.newImage(dataURL)
                .then((res) => {
                    setTimeout(() => {
                        this.setState({ working: false });
                        const uri = Config.TWITTER_IMAGE_SHARE + encodeURI(res.data.url);
                        if (!windowReference) window.open(uri, '_blank');
                        else windowReference.location = uri;
                    }, 500);
                });
        });
    }

    getDataUrl() {
        let canvas = this.state.canvas;
        let image = canvas.offsetParent.getElementsByTagName('img')[0];

        let background = new Image();
        background.src = '/comics/proxy?url=' + image.getAttribute('src');

        return new Promise(function(resolve) {
            background.onload = resolve;
        }).then(() => {
            // Create an ImageData object from it
            // let canvas = this.state.canvas;
            let context = this.state.context;
            let imagedata = context.getImageData(0, 0, this.state.canvas.width, this.state.canvas.height);
            let isPencil = this.state.pencil;
            let isEraser = this.state.eraser;

            // removes the white from the eraser when the background image is loaded in (canvas bug)
            context.globalCompositeOperation = 'destination-over';
            context.putImageData(imagedata, 0, 0);
            context.drawImage(background, 0, 0, background.width, background.height, 0, 0, canvas.width, canvas.height);
            let dataURL = canvas.toDataURL('image/png');
            context.globalCompositeOperation = (!isPencil && isEraser) ? 'destination-out' : 'source-over';

            return dataURL;
        });
    }

    isSafari() {
        return (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1);
    }

    handleImageSubmit() {
        this.getDataUrl().then((dataURL) => {
            this.setState({
                uploadForm: true,
                imageDataUrl: dataURL
            });
        });
    }

    uploadFormClose() {
        this.setState({
            uploadForm: false
        });
    }

    newImage(dataURL, metadata = {}, save = false) {
        return fetch(Config.IMAGE_UPLOAD_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'dataURL': dataURL,
                    'save': save,
                    'metadata': metadata
                })
            })
            .then(res => {
                return res.json();
            })
            .catch((err) => {
                console.log(err);
            });
    }

}

export default Comic;



// WEBPACK FOOTER //
// ./src/client/components/drawing-canvas/index.js